import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import OrderStaticTableCell from './OrderStaticTableCell';

/**
 * 영역별 색상 정의 (본문용)
 */
const forecastBodyColors = {
  OA: '#f1f8fe', // 수주 (Blue)
  HM: '#fff9f2', // 포캐스팅 (Orange)
  ES: '#f1faf2', // 예상실적 (Green)
};

const OrderStaticsEmpRows = ({ headerRows, data, useKorean, selectPrjTyp }) => {
  if (!headerRows || !data) {
    return null;
  }
  
  // 제외할 ID 목록 정의
const EXCLUDE_IDS = ['97d03a62-9a55-4ead-a0fd-313234b11e73', '8c75f20f-1e93-4900-9884-279a62226f55'];

return (
  data &&
  data.map((hq, hqIndex) => {
    // 1. 현재 본부(hq) 데이터에서 특정 ID 직원을 먼저 제외하고 rowSpan을 가공합니다.
    const cleanedHq = hq ? {
      ...hq,
      children: hq.children?.map(dp => {
        const filteredEmployees = dp.children?.filter(emp => !EXCLUDE_IDS.includes(emp.id)) || [];
        return {
          ...dp,
          children: filteredEmployees,
          rowSpan: filteredEmployees.length // 줄어든 부서 직원 수만큼 부서 rowSpan 갱신
        };
      }) || []
    } : null;

    // 본부(hq)의 총 rowSpan도 하위 부서들의 수정된 rowSpan 합으로 재계산
    if (cleanedHq) {
      cleanedHq.rowSpan = cleanedHq.children.reduce((acc, dp) => acc + (dp.rowSpan || 0), 0);
    }

    // 2. 가공된 cleanedHq 데이터를 바탕으로 화면을 렌더링합니다.
    return cleanedHq?.children?.map((dp, dpIndex) => {
      return dp?.children?.map((emp, empIndex) => {
        
        const isTotalRow = emp.id === 'total' || emp.id === 'one';
        const subtotalBgColor = '#eeeeee'; 
        const bottomBorder = isTotalRow ? '2px solid #bbb' : '1px solid #eee';

        return (
          <TableRow 
            key={`${hqIndex}-${dpIndex}-${empIndex}`}
            sx={{ 
              backgroundColor: isTotalRow ? subtotalBgColor : 'inherit',
              '& .MuiTableCell-root': {
                borderBottom: bottomBorder
              }
            }}
          >
            {dpIndex === 0 && empIndex === 0 && emp.id !== 'total' && (
              <TableCell 
                rowSpan={cleanedHq.rowSpan} // 가공된 본부 rowSpan 적용
                sx={{ 
                  width: selectPrjTyp === 'A' ? '90px': '100px',
                  bgcolor: '#f5f5f5', 
                  fontWeight: 'bold',
                  borderRight: '1px solid #eee' 
                }} 
                align={'center'}
              >
                {cleanedHq.name}
              </TableCell>
            )}

            {empIndex === 0 && emp.id !== 'total' && (
              <TableCell 
                rowSpan={dp.rowSpan} // 가공된 부서 rowSpan 적용
                sx={{ 
                  width: selectPrjTyp === 'A' ? '90px': '110px',
                  bgcolor: '#f5f5f5',
                  fontWeight: 'bold',
                  borderRight: '1px solid #eee'
                }}
                align={'center'}
              >
                {dp.name}
              </TableCell>
            )}

            <TableCell
              sx={{ 
                width: '80px', 
                bgcolor: isTotalRow ? emp.id === 'total' ? '#edf2f7' : '#f5f5f5' :'#ffffff',
                fontWeight: isTotalRow ? 'bold' : 'normal',
                color: isTotalRow ? '#000' : 'inherit',
                borderRight: '1px solid #eee'
              }}
              align={emp.id === 'total' ? 'center' : emp.id === 'one' ? 'right' : 'center'}
              colSpan={emp.id === 'total' ? 3 : 1}
            >
              {emp.name}
            </TableCell>
            <OrderStaticTableCell 
              headerRows={headerRows} 
              data={emp} 
              bodyColors={forecastBodyColors} 
              isTotalRow={isTotalRow}   
              useKorean={useKorean}
              selectPrjTyp={selectPrjTyp}        
            />
          </TableRow>
        );
      });
    });
  })
);

};

export default OrderStaticsEmpRows;
